import { render } from "./SolutionsCTA.vue?vue&type=template&id=5a1ff57a&lang=pug"
import script from "./SolutionsCTA.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionsCTA.vue?vue&type=script&setup=true&lang=js"

import "./SolutionsCTA.vue?vue&type=style&index=0&id=5a1ff57a&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__